import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ProductStocksService } from 'src/app/services/product-stocks.service';

@Component({
  selector: 'app-stock-lines',
  templateUrl: './stock-lines.component.html',
  styleUrls: ['./stock-lines.component.scss']
})
export class StockLinesComponent implements OnChanges {
  @Input() productId!: number;
  @Input() partnerId!: number;
  @Input() productVariantId?: number;

  @Input() filters: any = {};

  stockLines: any[] = [];
  count = 0;

  page = 1;
  limit = 20;

  loading = false;
  errorMessage = '';

  private filterTimer: any;

  constructor(private stockService: ProductStocksService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.productId || !this.partnerId) {
      return;
    }

    if (changes.filters && !changes.filters.firstChange) {
      this.page = 1;
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.loadStockLines();
      }, 350);
      return;
    }

    this.loadStockLines();
  }

  async loadStockLines(): Promise<void> {
    this.loading = true;
    this.errorMessage = '';

    try {
      const response = await this.stockService.getStockLines(
        this.productId,
        this.partnerId,
        {
          productVariantId: this.productVariantId,
          search: this.filters?.search,
          dateFrom: this.filters?.dateFrom,
          dateTo: this.filters?.dateTo,
          status: this.filters?.status,
          page: this.page,
          limit: this.limit,
        },
      );

      this.stockLines = response.data;
      this.count = response.count;
    } catch (error: any) {
      this.errorMessage = this.getBackendErrorMessage(error);
      this.stockLines = [];
      this.count = 0;
    } finally {
      this.loading = false;
    }
  }

  get totalPages(): number {
    return Math.max(Math.ceil(this.count / this.limit), 1);
  }

  nextPage(): void {
    if (this.page >= this.totalPages) {
      return;
    }

    this.page++;
    this.loadStockLines();
  }

  prevPage(): void {
    if (this.page <= 1) {
      return;
    }

    this.page--;
    this.loadStockLines();
  }

  private getBackendErrorMessage(error: any): string {
    if (error?.error?.message) {
      if (Array.isArray(error.error.message)) {
        return error.error.message.join(', ');
      }

      return error.error.message;
    }

    if (typeof error?.error === 'string') {
      return error.error;
    }

    if (error?.message) {
      return error.message;
    }

    return 'Failed to load stock lines';
  }
}